import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
    companyTypes: [],
  },
  getters: {
    companyTypes: (state) => state.companyTypes,
  },
  mutations: {
    setCompanyTypes: (state, data) => {
      state.companyTypes = data;
    },
  },
  actions: {
    getCompanyTypes: async ({ commit, dispatch }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/company-types"
        );
        const { data } = response.data;
        commit("setCompanyTypes", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.somethingWentWrong")
        });
      }
    },
  },
};
